const TitlePlansMobile = () => {
  return (
    <div className="flex flex-col w-full items-center justify-center mt-20">
      <div className="flex">
        <p className="flex bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text text-4xl font-bold">
          Compare <span className="flex text-white">&nbsp; Plans </span>
        </p>
      </div>
    </div>
  );
};

export default TitlePlansMobile;
